/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Datasets_Show_More_LabelInputs */



/**
* | output |
* | --- |
* | "Show More Dataset Spaces" |
*
* @param {Datasets_Show_More_LabelInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const datasets_show_more_label = /** @type {((inputs?: Datasets_Show_More_LabelInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Datasets_Show_More_LabelInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Mehr Datensatz-Bereiche anzeigen")
	return /** @type {LocalizedString} */ ("Show More Dataset Spaces")
});